import { render, staticRenderFns } from "./BatchRefInput.vue?vue&type=template&id=32324f76"
import script from "./BatchRefInput.vue?vue&type=script&lang=ts"
export * from "./BatchRefInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports